@let storeProducts = storeProducts$ | async; @let useMobileLayout = useMobileLayout$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button (click)="back()" [defaultHref]="defaultBackHref"></ion-back-button>
    </ion-buttons>
    <ion-title>Store</ion-title>
  </ion-toolbar>
  <ion-toolbar color="success">
    <ion-icon src="/assets/svg/coins.svg" slot="start" class="tw:ml-4"></ion-icon>
    <ion-title class="tw:text-sm">{{this.virtualCurrency$ | async | number}} {{virtualCurrencyLabel}}</ion-title>
    <ion-icon src="/assets/svg/coins.svg" slot="end" class="tw:mr-4"></ion-icon>
  </ion-toolbar>
</red-header-content>
<red-page-content>
  @if (storeProducts && !storeProducts.length) {
  <div class="tw:m-4 tw:text-xs">
    <ion-note color="medium">There are no purchasable products to display in the store at the moment.</ion-note>
  </div>
  }
  <div class="tw:grid" [ngClass]="{ 'tw:grid-cols-1': useMobileLayout, 'tw:grid-cols-2': !useMobileLayout}">
    @for (storeProduct of storeProducts; track productTrackBy($index, storeProduct)) {
    <ion-card [button]="true" (click)="openPaywall(storeProduct)">
      <div class="tw:relative tw:mt-2 tw:h-20">
        <img alt="In App Purchase" class="tw:object-contain" ngSrc="/assets/img/primary-subscription.png" fill />
      </div>
      <ion-card-header>
        <ion-card-title class="tw:text-center">{{storeProduct.name}}</ion-card-title>
        <ion-card-subtitle class="tw:text-center">
          {{storeProduct.type === storeProductEnum.Subscription ? 'Subscription' : storeProduct.type ===
          storeProductEnum.Consumable ? 'Consumable' : 'Permanent Unlock'}}
        </ion-card-subtitle>
      </ion-card-header>
      @if (!storeProduct.isOwned) {
      <ion-button expand="block" class="tw:mx-3 tw:mb-3">
        <ion-icon slot="start" name="cart-outline"></ion-icon>
        {{ storeProduct.priceText }}
      </ion-button>
      } @if (storeProduct.isOwned) {
      <ion-label color="success" class="tw:mx-3 tw:mb-3 tw:block tw:text-center tw:text-lg tw:font-bold">
        Active
      </ion-label>
      }
    </ion-card>
    }
  </div>
</red-page-content>
